import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';
import { QuarantineItem } from '@/pages/App/TestQuarantinePage/TestQuarantinePage.types';
type GetTestQuarantineListResponse = {
  canChange: boolean;
  testCases: QuarantineItem[];
};

export const testQuarantineListPath = (projectSlug: string) => {
  return `/app/${projectSlug}/quarantine/test_case`;
};

const useTestQuarantineList = (
  projectSlug: string,
  opts?: UseMonolithApiQueryOptions<GetTestQuarantineListResponse, unknown>,
) =>
  useMonolithApiQuery<GetTestQuarantineListResponse, unknown>(
    ['test-quarantine', projectSlug],
    testQuarantineListPath(projectSlug),
    opts,
  );

export default useTestQuarantineList;
